@if (isError) {
  <div class="h-full">
    <app-something-went-wrong
      (retryEmitter)="init()"></app-something-went-wrong>
  </div>
}
